<script lang="ts" setup></script>

<!-- layouts/paymentLayout.vue -->
<template>
  <div class="main">
    <slot />
  </div>
</template>

<style scoped>
.main {
  min-height: 100dvh;
  height: 100dvh;
  width: 100%;
  background: var(--background-color, #ffffff);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-wrap: wrap;
}
</style>
